import { useEffect } from 'react';
import { imgV2 as img } from '@styles/utils';
import parse from 'html-react-parser';

import { IProduct } from '@interfaces';
import { categoryMapSingle } from '@components/common/products/utils';
import { usePDPVideoModal } from '@components/common/presentational/modal/common';
import Clickable from '@v2/components/common/presentational/clickables/default';

import styles from '@components/common/products/product.styles';
import { scrollIntoView } from '@v2/utils/scroll';

export default function ProductDescription({ product, playVideo }: { product?: IProduct, playVideo?: boolean }) {
    const [showPDPVideoModal] = usePDPVideoModal(product.video);

    useEffect(() => {
        if (product.video && playVideo) {
            showPDPVideoModal();
        }
    }, []);

    return (
        <div className={styles.description}>
            <div className="right">
                <div className="right-wrapp animate__animated animate__fadeInUp-home">
                    <div className="pdp-header">
                        <h3>{categoryMapSingle(product.category)}</h3>
                        <p className="pdp-net-weight">Net wt. {product.weight}</p>
                    </div>
                    <h2>{product.title}</h2>
                    <p className="pdp-desc">
                        {parse(product.description)}
                    </p>
                    <div className="explanation-video">
                        {product.video ? <Clickable onClick={() => showPDPVideoModal()}>
                            <div className="video-box">
                                <div className="video-image">
                                    <img src={img('pdp2/product-description/doc.png')} alt="" />
                                </div>
                                <div className="video-controls">
                                    <div className="control">
                                        <img src={img('pdp2/product-description/play.svg')} alt="" />
                                    </div>
                                    <div className="heading">
                                        <span>our founder explains</span>
                                        <h4>{product.title}</h4>
                                    </div>
                                </div>
                            </div>
                        </Clickable> : null}
                        <Clickable onClick={() => scrollIntoView('safety')}>
                            <div className="directions-safety">
                                <img className="info-icon" src={img('pdp2/info-icon.svg')} alt="" />
                                <span className="heading">directions & safety</span>
                            </div>
                        </Clickable>
                    </div>
                </div>
            </div>
        </div>
    );
}